import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user, isAuthenticated, isRoot, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen bg-sp-light flex items-center justify-center">
                <div className="animate-spin w-8 h-8 border-4 border-sp-primary border-t-transparent rounded-full" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (adminOnly && !isRoot) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;